import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function GameModeRulesModal({ open, onClose, mode, t }) {
  const prefix = `groups.${mode}`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <strong>{t(`${prefix}.rulesTitle`)}</strong>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          {t(`${prefix}.rulesIntro`)}
        </Typography>
        {mode === 'tournament' ? (
          <>
            <Typography variant="body2" sx={{ mb: 1.5 }}>{t(`${prefix}.rulesDraw`)}</Typography>
            <Typography variant="body2" sx={{ mb: 1.5 }}>{t(`${prefix}.rulesPace`)}</Typography>
          </>
        ) : (
          <>
            <Typography variant="body2" sx={{ mb: 1.5 }}>{t(`${prefix}.rulesPace`)}</Typography>
            <Typography variant="body2" sx={{ mb: 1.5 }}>{t(`${prefix}.rulesTable`)}</Typography>
          </>
        )}
        <Typography variant="body2" sx={{ mb: 1.5 }}>{t(`${prefix}.rulesRestart`)}</Typography>

        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>
          {t(`${prefix}.rulesTieBreakTitle`)}
        </Typography>
        <Box component="ol" sx={{ m: 0, pl: 2.5 }}>
          {[1, 2, 3, 4, 5].map((i) => (
            <Typography key={i} component="li" variant="body2" sx={{ mb: 0.5 }}>
              {t(`${prefix}.rulesTieBreak${i}`)}
            </Typography>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
